if (!customElements.get("delivery-timeline")) {
  customElements.define(
    "delivery-timeline",
    class DeliveryTimeline extends HTMLElement {
      connectedCallback() {
        const target = this.querySelector("[data-delivery-dates]");
        if (!target) return;
        const minDays = parseInt(this.dataset.minDays, 10) || 0;
        const maxDays = Math.max(parseInt(this.dataset.maxDays, 10) || 0, minDays);
        const skipWeekends = this.dataset.excludeWeekends === "true";
        const start = this.format(this.addDays(minDays, skipWeekends));
        const end = this.format(this.addDays(maxDays, skipWeekends));
        target.textContent = start === end ? start : `${start} - ${end}`;
      }

      addDays(days, skipWeekends) {
        const date = new Date();
        if (!skipWeekends) {
          date.setDate(date.getDate() + days);
          return date;
        }
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return date;
      }

      format(date) {
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(date.getDate());
        if (this.dataset.dateFormat === "numeric") {
          return `${day}/${pad(date.getMonth() + 1)}`;
        }
        let month;
        try {
          month = new Intl.DateTimeFormat(document.documentElement.lang || "en", { month: "short" }).format(date);
        } catch (e) {
          month = date.toLocaleString("en", { month: "short" });
        }
        return this.dataset.dateFormat === "dmy" ? `${day} ${month}` : `${month} ${day}`;
      }
    }
  );
}
